import { render, staticRenderFns } from "./SkupoviKotizacije.vue?vue&type=template&id=4c4aed8e&scoped=true&"
import script from "./SkupoviKotizacije.vue?vue&type=script&lang=js&"
export * from "./SkupoviKotizacije.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4aed8e",
  null
  
)

export default component.exports